export default "__VITE_ASSET__22DAu0k1__"